import { Button, Stack, Typography } from '@mui/material';
import TrashIcon from 'Components/Icons/TrashIcon';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    setModalOpen,
    setModalType,
    setParseDataOfCsvFile,
    setSelectedCsvItem,
    setSelectedCsvItemIndex
} from 'store/ResponseTemplate/actions';

const DeleteTemplateCSV = () => {
    const dispatch = useDispatch();
    const { parsedCsvData, selectedCsvItemIndex } = useSelector((params) => params.response);

    const handleClose = () => {
        dispatch({ type: setModalOpen, modalOpen: false });
        dispatch({ type: setModalType, modalType: '' });
    };

    const handleRemove = () => {
        const newParsedCsvData = [...parsedCsvData];
        newParsedCsvData.splice(selectedCsvItemIndex, 1);
        dispatch({ type: setParseDataOfCsvFile, parsedCsvData: newParsedCsvData });
        // handleClose();

        dispatch({ type: setModalOpen, modalOpen: false });
        dispatch({ type: setModalType, modalType: 'list_csv_data' });
        dispatch({ type: setModalOpen, modalOpen: true });
        dispatch({ type: setSelectedCsvItem, selectedCsvItem: null });
        dispatch({ type: setSelectedCsvItemIndex, selectedCsvItemIndex: -1 });
    };

    return (
        <Stack gap={4}>
            <Typography variant="h6" component="h2" color="#00214D" fontSize="1.25rem" fontWeight="400" fontFamily="Poppins">
                Remove this question?
            </Typography>

            <Stack direction="row" justifyContent="flex-end" gap="10px">
                <Button
                    variant="outlined"
                    startIcon={<TrashIcon />}
                    disableRipple
                    sx={{
                        border: '1px solid #FF3E4A',
                        color: '#FF3E4A',

                        '&:hover': {
                            background: '#FF3E4A',
                            borderColor: '#FF3E4A',
                            color: '#fff',

                            svg: {
                                path: {
                                    fill: '#fff'
                                }
                            }
                        }
                    }}
                    onClick={handleRemove}
                >
                    Remove
                </Button>
                <Button className="alternate" onClick={handleClose}>
                    Keep Questions
                </Button>
            </Stack>
        </Stack>
    );
};

export default DeleteTemplateCSV;
